

import { Component} from '@angular/core';
import { AuthService } from './services/auth.service';
@Component({
 selector: 'app-root',
 templateUrl: './app.component.html',
 styleUrls: ['./app.component.scss']
})
export class AppComponent {
 title = 'eAuditWeb';
 constructor(private readonly authService: AuthService) {}

 ngOnInit():void {
  console.log('tes app component');
  this.authService.fetchToken(); 
 }
}